import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';

import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { AppLoader } from '@ingrid/luterkort-react';

import { I18nProvider } from '~src/i18n/i18n-config';
import '~src/styles/fonts.css';
import '~src/styles/global.css';

import { AuthProvider } from './providers/AuthProvider';
import { LoggingProvider } from './providers/LoggingProvider';
import { PermissionProvider } from './providers/PermissionProvider';
import { QueryClientProvider } from './providers/QueryClientProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { TrackingProvider } from './providers/TrackingProvider';
import { router } from './router';

createRoot(document.getElementById('root')!).render(
  <LoggingProvider>
    <TrackingProvider>
      <AuthProvider>
        <QueryClientProvider>
          <I18nProvider>
            <ThemeProvider>
              <StrictMode>
                <PermissionProvider>
                  <NuqsAdapter>
                    <Suspense fallback={<AppLoader />}>
                      <RouterProvider router={router} />
                    </Suspense>
                  </NuqsAdapter>
                </PermissionProvider>
              </StrictMode>
            </ThemeProvider>
          </I18nProvider>
        </QueryClientProvider>
      </AuthProvider>
    </TrackingProvider>
  </LoggingProvider>
);
